// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageHeader__root--QVHw {
    margin-bottom: 32px;
}

.PageHeader__wrapper--Lhy9 {
    margin-bottom: 44px;
    display: flex;
    flex-direction: column;
    gap: 24px;

}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PageHeader__wrapper--Lhy9 {
        display: grid;
        grid-template-columns: 303px auto;
        grid-gap: 24px;
        margin-bottom: 32px

}
    }

.PageHeader__title--jqRp {
    font-size: 30px;
    font-weight: 700;
    line-height: 40px;
    color: var(--secondary-color);
}

.PageHeader__description--CylZ {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: var(--secondary-color);
    padding-left: 24px;
    border-left: 1px solid currentColor;
    display: inline-flex;
    align-items: center;
}

.PageHeader__backgroundImage--qkfE {
    width: 100%;
    height: 200px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 6px;
    overflow: hidden;
    background-image: var(--mobile-bg-image);
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PageHeader__backgroundImage--qkfE {
        background-image: var(--desktop-bg-image)
}
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/PageHeader/PageHeader.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;;AASb;;AAPI;;AANJ;QAOQ,aAAa;QACb,iCAAiC;QACjC,cAAc;QACd;;AAGR;IAFI;;AAIJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,mCAAmC;IACnC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAK5C;;AAHI;;AAVJ;QAWQ;AAER;IADI","sourcesContent":[".root {\n    margin-bottom: 32px;\n}\n\n.wrapper {\n    margin-bottom: 44px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    @media (--large), (--small-tablet) {\n        display: grid;\n        grid-template-columns: 303px auto;\n        grid-gap: 24px;\n        margin-bottom: 32px;\n    }\n\n}\n\n.title {\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 40px;\n    color: var(--secondary-color);\n}\n\n.description {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 20px;\n    color: var(--secondary-color);\n    padding-left: 24px;\n    border-left: 1px solid currentColor;\n    display: inline-flex;\n    align-items: center;\n}\n\n.backgroundImage {\n    width: 100%;\n    height: 200px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    border-radius: 6px;\n    overflow: hidden;\n    background-image: var(--mobile-bg-image);\n\n    @media (--large), (--small-tablet) {\n        background-image: var(--desktop-bg-image);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PageHeader__root--QVHw`,
	"wrapper": `PageHeader__wrapper--Lhy9`,
	"title": `PageHeader__title--jqRp`,
	"description": `PageHeader__description--CylZ`,
	"backgroundImage": `PageHeader__backgroundImage--qkfE`
};
export default ___CSS_LOADER_EXPORT___;
